/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Api_Keys_Delete_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete \"{name}\"? This action cannot be undone." |
*
* @param {Api_Keys_Delete_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const api_keys_delete_confirm_description = /** @type {((inputs: Api_Keys_Delete_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Delete_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie "${i?.name}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.`)
	return /** @type {LocalizedString} */ (`Are you sure you want to delete "${i?.name}"? This action cannot be undone.`)
});